/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum OccursInterval {
    Daily = 0,
    Weekly = 1,
    Monthly = 2,
    BiWeekly = 3,
}
